module.exports = __webpack_public_path__ + "img/da.2f77fa65.png";